import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TextField, Autocomplete } from '@mui/material'
import {
  changeDependencyValues,
  getDropdownOptions
} from '../../redux/DynamicForms/dynamicFormsActions'

export default function SelectBox(props) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getDropdownOptions(props.id))
    if (props.value) {
      let ev = {
        target: {
          name: props.serviceKey,
          value: props.value
        }
      }
      props.onChange(ev, props.id, props.value)
    }
    console.log(props, 'props')
  }, [])

  const onDropDownValueChange = (ev, newValue) => {
    console.log(newValue, 'selectg')
    props.onChange(ev, newValue, props.id, props.serviceKey)

    dispatch(changeDependencyValues(props.id))
  }

  return (
    <Fragment>
      <Autocomplete
        disablePortal
        options={props?.options}
        getOptionLabel={option => option?.label || ''}
        getOptionKey={option => option?.value || ''}
        onChange={(ev, newValue) => onDropDownValueChange(ev, newValue)}
        renderInput={params => (
          <TextField
            value={props.value}
            {...params}
            label={props.label}
            name={props.serviceKey}
            id={props.serviceKey}
          />
        )}
      />
    </Fragment>
  )
}
